import { ConfirmDialog } from "primereact/confirmdialog";
import { ProgressSpinner } from "primereact/progressspinner";
import React, { Suspense } from "react";
import { useLazyLoadQuery } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import {
	type ordersScreen_Query,
	type ordersScreen_Query$data,
} from "@relay/ordersScreen_Query.graphql";
import { ORDERS_QUERY, ordersPerPage } from "./orders.graphql";
import { BaseScreen } from "../../components/base-screen";
import { NoAccess } from "../../components/no-access";
import { OrdersTable } from "../../features/orders/orders-table/orders-table.component";
import { useHasPermissions } from "../../hooks/use-has-permissions";

export const OrdersScreen = () => {
	const { t } = useTranslation("common");
	const orders: ordersScreen_Query$data = useLazyLoadQuery<ordersScreen_Query>(ORDERS_QUERY, {
		numItemsPerPage: ordersPerPage,
	});

	const canRead = useHasPermissions(["UserInAccountPermission_OrderAdmin_Read"]);
	const canModify = useHasPermissions(["UserInAccountPermission_OrderAdmin_Modify"]);

	if (!canRead) return <NoAccess />;

	return (
		<BaseScreen title={t("order.screenTitle")}>
			<Suspense fallback={<ProgressSpinner />}>
				<OrdersTable
					ordersFragmentRef={orders}
					ordersPerPage={ordersPerPage}
					enableFilter={true}
					canModifyOrders={canModify}
				/>
			</Suspense>
			<ConfirmDialog />
		</BaseScreen>
	);
};
